import HBMediaElement from '../honeybook-ui/HBMediaElement/HBMediaElement';
import HBText from '../honeybook-ui/HBText/HBText';

interface ISuggestionPreviewProps {
    title: string;
    iconUrl: string;
    onClick: () => void;
    isSelected: boolean;
}

const SuggestionPreview = ({
    title,
    iconUrl,
    onClick,
    isSelected
}: ISuggestionPreviewProps) => {
    return (
        <div
            className={`broad-intent-hero--chat__suggestion ${
                isSelected
                    ? 'broad-intent-hero--chat__suggestion--selected'
                    : ''
            }`}
            onClick={onClick}
        >
            <HBText
                tag="span"
                type="body-xs"
                customClass="broad-intent-hero--chat__suggestion__label"
            >
                {title}
            </HBText>
            <HBMediaElement
                name={iconUrl}
                customClass="broad-intent-hero--chat__suggestion__icon"
            />
        </div>
    );
};

export default SuggestionPreview;
